import { create } from 'zustand';

export const useStore = create((set, get) => ({
  isMenuOpen: false,
  setIsMenuOpen: (isMenuOpen) => set({ isMenuOpen }),
  isPopupOpen: false,
  setIsPopupOpen: (isPopupOpen) => set({ isPopupOpen }),

  menuLinks: [
    {
      name: 'Inicio',
      url: '/'
    },
    {
      name: 'Quiero ser Punto HOP',
      url: '/quiero-ser-punto-hop'
    },
    {
      name: 'HOP para tu negocio',
      url: '/hop-para-tu-negocio'
    },
    {
      name: 'Conocenos',
      url: '/conocenos'
    },
    {
      name: 'Contacto',
      url: '/contacto'
    },
    {
      name: 'Paquetería',
      url: '/paqueteria'
    },
    {
      name: 'Portales',
      children: [
        { name: 'Portal Clientes', url: 'https://clientes.hopenvios.net/', external: true },
        { name: 'Portal Autogestión Casos', url: 'https://hopsellersposventa.powerappsportals.com/', external: true }
      ]
    }
  ],

  footerNav1: [
    {
      name: 'Conocenos',
      url: '/conocenos'
    },
    {
      name: 'Contacto',
      url: '/contacto'
    }
    /*{
      name: 'Impacto',
      url: '/conocenos#impacto'
    }*/
  ],

  footerNav2: [
    /*{
        name: 'Novedades',
        url: '/novedades'
      },
      {
        name: 'Developers',
        url: '/developers'
      },
      {
        name: 'Careers',
        url: '/'
      } */
  ],

  footerNav3: [
    {
      name: 'Conocé los Puntos HOP',
      url: '/conoce-los-puntos-hop'
    },
    {
      name: 'Quiero ser Punto HOP',
      url: '/quiero-ser-punto-hop'
    },
    {
      name: 'Materiales publicitarios',
      url: '/materiales-publicitarios'
    },
    {
      name: 'HOP para tu negocio',
      url: '/hop-para-tu-negocio'
    },
    {
      name: 'Referidos',
      url: '/referidos'
    }
  ],

  setMenuLinks: (menuLinks) => set({ menuLinks }),

  isLoaded: false,
  setIsLoaded: (isLoaded) => set({ isLoaded }),

  isLenisOpts: {
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false
  },
  setIsLenisOpts: (isLenisOpts) => set({ isLenisOpts })
}));